var angular = require('angular');

function SuggestedRoute(suggestedRoute) {
  angular.extend(this, suggestedRoute);
}

module.exports = SuggestedRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/suggestedRoute.js
 ** module id = 193
 ** module chunks = 1
 **/